import { render, staticRenderFns } from "./SortToggle.vue?vue&type=template&id=476ec9d7&"
import script from "./SortToggle.vue?vue&type=script&lang=ts&"
export * from "./SortToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports